import { styled, Box, Stack, Chip } from "@mui/material";

export const ExportOptionsRoot = styled(Box)(({ theme, show }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
}));

export const ExportOptionsBlock = styled(Box)(({ theme, divider }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  position: "relative",
  padding: ".75rem 2.5px",
  paddingRight: "2rem",
  width: "auto",
  // maxWidth: "27dvw",
  [theme.breakpoints.up("md")]: {
    paddingRight: "2.5rem",
  },
  [theme.breakpoints.up("xl")]: {
    padding: "0.8rem 2.5rem",
  },
  "&:before": {
    content: '""',
    display: divider ? "block" : "none",
    position: "absolute",
    right: "1rem",
    bottom: 5,
    width: 1,
    margin: "auto",
    height: "59%",
    zIndex: 5,
    background: theme?.palette?.companyColors?.greyLight1,
  },
}));

export const ExportOptionsStack = styled(Stack)(({ theme, columns }) => ({
  display: "grid",
  gridTemplateColumns: `repeat(${columns}, auto)`,
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexWrap: "wrap",
  gap: "0.75rem 0.75rem",
  [theme.breakpoints.up("xl")]: {
    gap: "0.85rem 0.75rem",
  },
}));

export const ExportOptionsChip = styled(Chip)(({ theme, selected }) => ({
  fontSize: "1.25rem",
  padding: "2px 5px",
  marginLeft: "0 !important",
  lineHeight: 1.25,
  height: 25,
  color: selected
    ? theme?.palette?.companyColors?.neutral
    : theme?.palette?.companyColors?.secondary,
  background: selected
    ? theme?.palette?.companyColors?.primary
    : theme?.palette?.companyColors?.greyLight1,
  svg: {
    fill: selected
      ? theme?.palette?.companyColors?.neutral
      : theme?.palette?.companyColors?.secondary,
  },
  ".MuiChip-label": {
    lineHeight: 1.5,
  },
}));
